// hook/urlUtils.ts
export function buildUrl(
  basicTab: string,
  selectedRDV: string | number | '',
  filters?: Record<string, any>,
  orderGroup?: string | ''
) {
  if (!selectedRDV) return undefined;

  const codiceUtente = localStorage.getItem('codiceUtente') || '';
  const base = `/tables/${encodeURIComponent(basicTab)}?ID=${encodeURIComponent(String(selectedRDV))}`;
  const params = new URLSearchParams();

  if (codiceUtente) params.set('codiceUtente', codiceUtente);

  if (filters) {
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== '' && v !== null && v !== undefined) params.append(k, String(v));
    });
  }

  if (orderGroup) params.set('orderGroup', orderGroup);

  const qs = params.toString();
  return qs ? `${base}&${qs}` : base;
}
